/**
 * Générateur — Automatisme : nombre quotient.
 * Attendu ID : 1063 | Niveau : 5ème | Domaine : Calcul littéral et algébrique
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 8, ligne 603 :
 * « Nombre quotient. », seul, sans exemple ni forme).
 *
 * ── WRAPPER (cadrage du sous-agent programme-maths, arbitré le 2026-09-10) ──
 * C'est le même automatisme que la ligne 552, rubrique Nombres rationnels :
 * « Faire vivre la notion de nombre quotient en complétant des multiplications
 * à trou : 3 × … = 7 puis 3 × 7/3 = … », déjà livré par gen_1049. Ce gen
 * DÉLÈGUE intégralement : zéro duplication, une seule maintenance. Le payload
 * est re-badgé (attendu 1063) ; cartes, formats, generator_keys, invariants,
 * distracteurs et couple sacrifié (4 × 13) sont ceux de 1049. Coup de pouce et
 * solveurs réutilisent l'entrée 1049 (coupsDePouce/index.js, solvers/index.js).
 *
 * POURQUOI LE PROGRAMME LE RANGE ICI AUSSI, et ce que ça change : le cycle 3
 * (l. 978) écrit que la définition du quotient « est mobilisée dans la
 * résolution d'égalités à trous, qui préfigurent celle de l'équation a × x = b,
 * ouvrant ainsi la voie à la pensée algébrique ». C'est donc une intention de
 * PROGRESSION, pas un contenu de plus : on entretient ici le même geste parce
 * qu'il prépare ax = c. Le programme fait le même double rangement en 4e
 * (l. 636 Opérations et l. 655 Rationnels), et la ligne 603 est NUE quand celle
 * des rationnels est détaillée : une ligne qui viserait autre chose le dirait.
 *
 * Ce que ce contexte NE permet pas d'ajouter, chacun ayant son propre attendu :
 * la lettre et la résolution de ax = c (objectif l. 617-619, « donner à la
 * lettre le statut d'inconnue »), l'écriture en division et le lien × ÷
 * (automatisme de 4e, l. 636), les coefficients décimaux (domaine de
 * l'objectif). Frontières voisines inchangées : 621 (6e, l'apprentissage de la
 * définition), 1048 (écriture décimale d'une fraction simple), 1055 (la
 * fraction opérateur, le 1/3 de 18).
 *
 * SEUL ÉCART AVEC 1049, à coût nul : la carte « Le nombre qui, multiplié
 * par… » passe EN PREMIER dans la liste que voit le prof. C'est elle qui pose
 * la question EN MOTS, celle qu'on reposera bientôt avec une lettre ; l'autre
 * carte porte l'écriture « 3 × … = 7 ». Mettre la lecture pré-algébrique en
 * avant est la seule chose que le rangement en calcul littéral justifie sans
 * sortir du périmètre de 5e.
 *
 * PAS de pondération du tirage sans format (épreuve de Musk) : elle a été
 * écrite puis retirée. Sans elle, 1049 tire déjà uniformément parmi quatre
 * clés dont TROIS sont `sens_*`, soit 75 % à la carte en mots ; la pondération
 * n'ajoutait qu'un écrasement de la carte « 3 × … = 7 » à 8 %, que personne
 * n'a demandé et qui recopiait dans ce fichier le nombre de clés de 1049.
 *
 * Point ouvert noté à la revue : aucun item DEPP ou Eduscol ne porte sur le
 * trou lui-même (« 3 × … = 7 ») ; l'item Eduscol 5e 2025 q.29 atteste le geste
 * inverse (« cinq fois trois cinquièmes »). Le verdict ne repose pas sur
 * l'attestation mais sur le texte du programme.
 */
import { generate as genererQuotient, CATEGORIES as CAT_QUOTIENT } from '../nombres-rationnels/gen_1049';

const ATTENDU_ID = 1063;

/** La carte en MOTS d'abord : c'est la lecture qui prépare l'équation. */
const estSens = (c) => c.id === 'sens';
export const CATEGORIES = [...CAT_QUOTIENT.filter(estSens), ...CAT_QUOTIENT.filter((c) => !estSens(c))];

export const generate = (typeExercice) => {
    const payload = genererQuotient(typeExercice);
    payload.attendu = ATTENDU_ID;
    return payload;
};
